import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Col, Divider, Row, Statistic } from "antd";
import {
  BarcodeOutlined,
  DollarCircleOutlined,
  DollarOutlined,
  ShoppingCartOutlined,
} from "@ant-design/icons";
import CountUp from "react-countup";
import TrademarkStatisticsContext from "../../../context/statistcs-trademark/context";
import { ICoordinates } from "../../../models/area/request";
import AppContext from "../../../context/app/context";
import ChartCustom from "../../general/charts/pie-costum";
import MapPolygon from "../../general/map/polygon";

const StatisticsSection = () => {     
  const { t } = useTranslation();
  const { list: statistics } = useContext(TrademarkStatisticsContext);
  const { direction } = useContext(AppContext);
  const [area, setArea] = useState([]);
  const [detailsArea, setDetailsArea] = useState([]);

    useEffect(() => { 

      const detailsPoints = statistics?.areaOrdersCount.map((item)=>{
        return {
          'points':item.points,
          'count':item.count,
          'name':item.name,
          'totalSales':item.totalSales
        }
      });
      setDetailsArea(detailsPoints)

    }, [direction]);

  return (
    <>
    <Row style={{ width: "100%", margin: 0 }} justify="center" align="middle" gutter={[16, 16]}>
      <Col xs={24} sm={12} md={6} style={{ textAlign: "center", padding: "10px 0" }}>
        <ShoppingCartOutlined style={{ fontSize: "50px", color: "#1890ff", marginBottom: "10px" }} />
        <Statistic
          title={<span style={{ fontSize: "18px", fontWeight: "500" }}>{t("Total Orders")}</span>}
          valueRender={() => (
            <CountUp start={0} end={statistics?.totalOrders || 0} duration={2.5} separator="," />
          )}
        />
      </Col>
      <Col xs={24} sm={12} md={6} style={{ textAlign: "center", padding: "10px 0" }}>
        <DollarCircleOutlined style={{ fontSize: "50px", color: "#1890ff", marginBottom: "10px" }} />
        <Statistic
          title={<span style={{ fontSize: "18px", fontWeight: "500" }}>{t("Total Sales")}</span>}
          valueRender={() => (
            <CountUp start={0} end={statistics?.totalSales || 0} duration={2.5} separator="," prefix="$" />
          )}
        />
      </Col>
      <Col xs={24} sm={12} md={6} style={{ textAlign: "center", padding: "10px 0" }}>
        <BarcodeOutlined style={{ fontSize: "50px", color: "#1890ff", marginBottom: "10px" }} />
        <Statistic
          title={<span style={{ fontSize: "18px", fontWeight: "500" }}>{t("Total Discount Codes")}</span>}
          valueRender={() => (
            <CountUp start={0} end={statistics?.totalIssuedCoupons || 0} duration={2.5} separator="," />
          )}
        />
      </Col>
      <Col xs={24} sm={12} md={6} style={{ textAlign: "center", padding: "10px 0" }}>
        <DollarOutlined style={{ fontSize: "50px", color: "#1890ff", marginBottom: "10px" }} />
        <Statistic
          title={<span style={{ fontSize: "18px", fontWeight: "500" }}>{t("Total Discount Value")}</span>}
          valueRender={() => (
            <CountUp start={0} end={statistics?.totalDiscountValue || 0} duration={2.5} separator="," prefix="$" />
          )}
        />
      </Col>
      <Divider orientation="center">{t("statistics")}</Divider>
      <Row style={{ width: "100%", margin: 0 }} justify="center" align="middle" gutter={[16, 16]}>
      <Col span={20} style={{ marginTop: "20px" }}>
          <MapPolygon
            showDefault={true}
            draggable={false}
            editable={false}
            allPoints={detailsArea.map((item)=>item.points)}
          />
          {/* <MapPolygon
            showDefault={true}
            draggable={false}
            editable={false}
            points={
              {
                type: "Polygon",
                coordinates: [
                  [
                    [36.286857, 33.522267],
                    [36.288, 33.523],
                    [36.2895, 33.5245],
                    [36.29, 33.5255],
                    [36.286857, 33.522267],
                  ],
                ],
              } as ICoordinates
            }
            allPoints={[]}
          /> */}
      </Col>
      <Row style={{ width: "80%", margin: 0}} justify="space-between" align="middle" gutter={[16, 16]} >
      <Col sm={8} xs={24} >
            <ChartCustom
              label={t("OrderCount")}
              lables={detailsArea.map((item)=>(item.name))}
              count={detailsArea.map((item)=>(item.count))}
            />
      </Col>
      <Col sm={8} xs={24} >
        <ChartCustom
          label={t("total_sales")}
          lables={detailsArea.map((item)=>(item.name))}
          count={detailsArea.map((item)=>(item.totalSales))}
        />
      </Col>
      </Row>
      </Row>
     

    </Row>
    
    </>
    
  );
};

export default StatisticsSection;
